import { Outlet } from "react-router-dom";

const AppPrivateRoute = ({ children }) => {
  const slotbook = localStorage.getItem("slotbook");
  let hasValidToken = false;
  try {
    const data = slotbook ? JSON.parse(slotbook) : null;
    hasValidToken = !!(data?.accessToken);
  } catch (_) {}

  if (!hasValidToken) {
    window.location.href = "/login";
    return null;
  }

  return children ? children : <Outlet />;
};

export default AppPrivateRoute;
